export const removeIssueGroupPrefix = (issueFullName: string) => {
  const parts = issueFullName.split(" / ");
  return parts.length > 1 ? parts.slice(1).join(" / ") : issueFullName;
};
